import React, { useState } from "react";
import { Box, Grid, TextField, MenuItem, Typography, Checkbox, FormControlLabel } from "@mui/material";
import { genders, races, roles, specialists } from "../../data";
import { useFormikContext } from "formik";
import { upperFirstLetter } from "../../constants/format";

const UserMenu = () => {
    const formik = useFormikContext();
    const [specialist, setSpecialist] = useState(false);

    function toggleSpecialist() {
        setSpecialist(!specialist);
    }

    return (
        <Box id="Name-menu-id">
            <Grid container spacing={3}>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="gender"
                        label="Gender"
                        value={formik.values.gender}
                        onChange={formik.handleChange("gender")}
                        select
                        fullWidth
                        variant="outlined"
                    >
                        {genders.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="race"
                        label="Race/Ethnicity"
                        value={formik.values.race}
                        onChange={formik.handleChange("race")}
                        select
                        fullWidth
                        variant="outlined"
                    >
                        {races.map((item, index) => (
                            <MenuItem key={index} value={item}>
                                {item}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>

                <Grid item xs={12} sm={6}>
                    <TextField
                        id="firstName"
                        label="First Name"
                        value={formik.values.firstName}
                        onChange={formik.handleChange("firstName")}
                        variant="outlined"
                        fullWidth
                        required
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        id="middleName"
                        label="Middle Name"
                        value={formik.values.middleName}
                        onChange={formik.handleChange("middleName")}
                        variant="outlined"
                        fullWidth
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        id="lastName"
                        label="Last Name"
                        value={formik.values.lastName}
                        onChange={formik.handleChange("lastName")}
                        variant="outlined"
                        fullWidth
                        required
                    />
                </Grid>

                <Grid item xs={12} sm={8}>
                    <TextField
                        id="role"
                        label="Role"
                        value={formik.values.role}
                        onChange={formik.handleChange("role")}
                        select
                        fullWidth
                        variant="outlined"
                        required
                    >
                        {(specialist ? specialists : roles).map((role) => (
                            <MenuItem key={role.value} value={role.label}>
                                {role.label}
                            </MenuItem>
                        ))}
                    </TextField>
                </Grid>
                <Grid item xs={12} sm={4} sx={{ display: 'flex', alignItems: 'center' }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={specialist}
                                onChange={toggleSpecialist}
                            />
                        }
                        label={
                            <Typography variant="body2">
                                Certified Specialist
                            </Typography>
                        }
                    />
                </Grid>

                <Grid item xs={12}>
                    <TextField
                        id="certification"
                        label="Certification (if applicable)"
                        variant="outlined"
                        fullWidth
                    />
                </Grid>
            </Grid>
        </Box>
    );
};

export default UserMenu;
